import React, { useState } from 'react';
import { ModalManager } from 'react-dynamic-modal';
import AresNavBar from '../Layout/NavBar/NavBar';
import SideBar from '../Layout/SideBar/SideBar';
import LocalizatorForm from './LocalizatorForm';
import LocalizatorTabs from './LocalizatorTabs';
import axios from '../../services/Api'
import DefaultModal from '../Util/Modal'
import swal from 'sweetalert';
import { downloadReport } from '../../utils/Report'

import './index.css'
import ConfigModal from '../Travel/config';

function Localizator() {
  const [tracker, setTracker] = useState(null);
  const [travel, setTravel] = useState(null);
  const [history, setHistory] = useState(null);
  const [loading, setLoading] = useState(false);

  const onSubmitLocalizator = async (cod) => {
    setTracker(cod)
    await getTravel(cod)
  }

  // Fetch travel data
  async function getTravel(localizatorId) {
    try {
      const response = await axios.get(`/api/travels/localizator/${localizatorId.cod}`)
      setTravel(response.data);
      return response.data;
    } catch (e) {
      console.log(e);
      swal("Erro!", "Não foi possível localizar esse trajeto", "error")
        .then(() => {
          window.location.reload();
        });
      return 'sem trajeto';
    }
  }

  // Fetch history device history
  async function getLog(device) {
    setLoading(true)
    try {
      const response = await axios.get(`/api/travels/${travel._id}/devices/${device.mac}/history`);
      setHistory(response.data);
      setLoading(false)
      return response.data;
    } catch (e) {
      console.log(e);
      swal("Erro!", "Não foi possível localizar pontos", "error");
      setLoading(false)
    }
  }

  // Create and downloading device excel reports 
  async function getExcelReports(id, mac) {
    try {
      reportLoading();
      const response = await axios.get(`api/travels/${id}/devices/${mac}/history/excel`);
      await downloadReport(`/api/report/files/${response.data._id}`, response.data.file);
      swal("Sucesso!", `Relátório foi baixado com sucesso`, "success");
      return response.data;
    } catch (e) {
      console.log(e);
      swal("Erro!", e.response ? e.response.data.error : e.message, "error");
    }
  }

  // Create and downloading device pdf reports 
  async function getPDFReports(id, mac) {
    try {
      reportLoading();
      const response = await axios.get(`api/travels/${id}/devices/${mac}/history/pdf`);
      await downloadReport(`/api/report/files/${response.data._id}`, response.data.file);
      swal("Sucesso!", `Relátório foi baixado com sucesso`, "success");
      return response.data;
    } catch (e) {
      console.log(e);
      swal("Erro!", e.response ? e.response.data.error : e.message, "error");
    }
  }

  function reportLoading() {
    swal({
      title: 'Aguarde...',
      showCancelButton: false,
      showCloseButton: false,
      showConfirmButton: false,
      text: 'O relatório está sendo gerado...'
    })
  }

  function reportExport(id, mac, fileType) {
    switch (fileType) {
      case 'excel':
        getExcelReports(id, mac)
        break;
      case 'pdf':
        getPDFReports(id, mac)
        break;
      default:
        break;
    }
  }

  // callback modal manager for graph and edit
  async function openChartDeviceModal(device, modal) {
    switch (modal) {
      case 'graph':
        getLog(device).then((history) => {
          ModalManager.open(<ConfigModal device={device} deviceData={history} status={modal} />)
        });
        break;
      case 'settings':
        ModalManager.open(<DefaultModal title="Configurar Dispositivo" component={<ConfigModal device={device} status={modal} />} />)
        break;
      default:
        break;
    }
  }

  return (
    <div className="Localizator sidenav-margin">
      <AresNavBar />
      <SideBar />
      <div className="content">
        <div className="container-header ">
          <h1>Localizador</h1>
        </div>
        <LocalizatorForm localizator={onSubmitLocalizator} />
        {tracker && <LocalizatorTabs
          cod={tracker}
          travel={travel}
          history={history}
          callbackDevices={getLog}
          loading={loading}
          reportCallback={reportExport}
          callbackModal={openChartDeviceModal}
        />}
      </div>
    </div>
  );
}

export default Localizator;